import { ReactNode } from "react";

interface ButtonProps {
  title: ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

function CustomeButton({ title, onClick, className,disabled,type }: ButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50 ${className}`}
      disabled={disabled}
      type={type}
    >
      {title}
    </button>
  );
}

export default CustomeButton;
